import { createAsyncThunk } from '@reduxjs/toolkit';
import { type } from './state';
import { orderService, GetOrdersResponse } from '../../services';
import { createClearAllAsyncThunk, createClearErrorAsyncThunk } from '../shared-actions';

export const getOrders = createAsyncThunk<GetOrdersResponse, { customerId: number }>(
    `${type}/getOrders`,
    async (args, { rejectWithValue }) => {
        try {
            return await orderService.getOrders(args.customerId);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const clearErrorsAction = createClearErrorAsyncThunk(type);
export const clearAllAction = createClearAllAsyncThunk(type);
